import { ESGImpactTypes } from './ESGImpactTypes';

export const ESGImpactLabels = {
  [ESGImpactTypes.ENVIRONMENT]: [
    'Airborne pollution',
    'Climate change',
    'Waterborne pollution',
    'Water consumption',
    'Land use',
  ],
  [ESGImpactTypes.SOCIAL]: ['Child labour', 'Compensation', 'Gender inequality', 'Health safety'],
  [ESGImpactTypes.GOVERNANCE]: ['Corruption', 'Taxes'],
};
